import { Game } from '@/types/globals'
import { RootState } from '@/store/store'
import { useSelector } from 'react-redux'
import { useState, useEffect } from 'react'
import { trackEvent } from '@/lib/trackEvent'
import Navbar from '@/components/shared/Navbar'
import { endpoints } from '@/services/api/endpoints'
import GameCard from '@/components/shared/GameCard'
import { axios } from '@/services/api/axiosInstance'
import DeleteGameModal from '@/components/shared/DeleteGameModal'

const MyGames = () => {
  const [games, setGames] = useState<Game[]>([])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)
  const { deleteModal } = useSelector((state: RootState) => state.system)

  useEffect(() => {
    fetchGames()
  }, [])

  const fetchGames = async () => {
    try {
      setLoading(true)
      const response = await axios.get(endpoints.getGames().url)
      const fetchedGames = response.data.data
      setGames(fetchedGames.reverse())
      trackEvent('Games Fetched', { count: response.data.data.length })
    } catch (err) {
      console.error('Error fetching games:', err)
      setError('Failed to fetch games. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Navbar />
      <main className="custom-scrollbar relative flex h-[calc(100dvh-64px)] flex-col gap-2 overflow-y-auto py-4 lg:px-4">
        {loading ? (
          <div className="flex size-full items-center justify-center">
            <div className="size-20 animate-pulse">
              <img src="/logo.png" alt="Loading" className="size-12" />
            </div>
          </div>
        ) : error ? (
          <div className="py-10 text-center text-red-500">Error: {error}</div>
        ) : games.length === 0 ? (
          <p className="py-10 text-center">
            You haven&apos;t created any games yet.
          </p>
        ) : (
          <div className="mx-auto grid max-w-7xl grid-cols-1 gap-5 px-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {games?.map((g: Game) => (
              <GameCard key={g?.game_id} game={g} setGames={setGames} />
            ))}
          </div>
        )}
        {deleteModal.show && <DeleteGameModal callBack={fetchGames} />}
      </main>
    </>
  )
}

export default MyGames
